<div class="nav-side-menu sidebar hover-d">
  <a href="javascript:void(0);" class="brand-link">
    <span class="logo-img"></span>
    <!-- <img class="brand-image" src="/assets/img/brand/logo-high-original.png" /> -->
    <!-- <img class="brand-minized-image" src="../../../assets/brand/logo-high-dark.jpg" /> --> <!--will use leter-->
  </a>

  <nav class="nav" role="navigation">
    <ul class="nav__list">
      <li class="client-key-item">
        <span class="client-key-label">
          <i class="fa fa-solid fa-calendar-days"></i>&nbsp;&nbsp;{{ dataManipSrvc.loginData?.clientkey }}
        </span>
      </li>
      <li>
        <a class="nav-link" routerLinkActive="active" routerLink="/dashboard"> <!--class="active"-->
          <span class="left-icon"><i class="fa fa-solid fa-chart-pie"></i></span>
          <span class="menu-name">Dashboard</span>
        </a>
      </li>

      <!---Master Menu-->
      <li class="sub-menu-li">
        <input id="group-1" type="radio" name="nav-main-group" hidden (change)="openSubGroup = null; openSubSubGroup = null" />
        <label class="nav-group" for="group-1">
          <span class="left-icon"><i class="fa fas nav-icon fa-desktop"></i></span>
          <span class="menu-name">Masters</span> <span class="right-arrow fa fa-angle-right"></span>
        </label>
        <ul class="group-list">
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/master/item-category/item-list"
              (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-solid fa-list"></i></span>
              <span class="menu-name">Item Category</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/master/crm/crm-list" (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-solid fa-briefcase"></i></span>
              <span class="menu-name">Manage Customers</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/master/account-master/account-master-list"
              (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-solid fa-gauge-high"></i></span>
              <span class="menu-name">Account Master</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/master/item-master/item-master-list"
              (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-solid fa-layer-group mr-1"></i></span>
              <span class="menu-name">Item Master</span>
            </a>
          </li>
          <!--second level menu  -->
          <li *ngIf="openSubGroup === null || openSubGroup === 'manageschemes'">
            <label class="nav-sub-group" [class.active-toggle]="openSubGroup === 'manageschemes'"
              (click)="toggleSubGroup('manageschemes')"><span class="left-icon"><i
                  class="fa fa-solid fa-wand-magic-sparkles"></i></span>
              <span class="menu-name">Manage Schemes and Members</span> <span class="right-arrow fa fa-angle-right"></span></label>
            <ul class="sub-group-list" [class.is-open]="openSubGroup === 'manageschemes'">
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/master/scheme-advance-master/member-master-list" (click)="togglemini()"><span
                    class="left-icon"><i class="fa fa-solid fa-gear"></i></span> <span class="menu-name">Member
                    Master</span></a></li>
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/master/scheme-advance-master/scheme-master-list" (click)="togglemini()"><span
                    class="left-icon"><i class="fa fa-solid fa-gear"></i></span> <span class="menu-name">Scheme
                    Master</span></a></li>

              <!-- <li><a href="#"><span class="left-icon"><i class="fa fas fa-tachometer-alt"></i></span> <span
                      class="menu-name">2nd level nav item</span></a>
                </li>
                <li>
                  <input id="sub-sub-group-1" type="checkbox" hidden />
                  <label for="sub-sub-group-1"><span class="left-icon"><i class="fa fas fa-tachometer-alt"></i></span>
                    <span class="menu-name">Third level</span> <span class="right-arrow fa fa-angle-right"></span></label>
                  <ul class="sub-sub-group-list">
                    <li><a href="#"><span class="left-icon"><i class="fa fas fa-tachometer-alt"></i></span> <span
                          class="menu-name">3rd level nav item</span></a></li>
                    <li><a href="#"><span class="left-icon"><i class="fa fas fa-tachometer-alt"></i></span> <span
                          class="menu-name">3rd level nav item</span></a></li>
                    <li><a href="#"><span class="left-icon"><i class="fa fas fa-tachometer-alt"></i></span> <span
                          class="menu-name">3rd level nav item</span></a></li>
                  </ul>
                </li> -->
            </ul>
          </li>
          <!-- /second level menu-->
          <!-- <li>
            <a class="nav-sub-link" routerLink="/master/company-master/company-list">
              <span class="left-icon"><i class="fa fa-solid fa-globe"></i></span> 
              <span class="menu-name">Company</span>
            </a>
          </li> -->
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/master/branch-master/branch-list"
              (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-regular fa-building"></i></span>
              <span class="menu-name">Manage Branches</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/master/section-master/manage-sections"
              (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-solid fa-layer-group"></i></span>
              <span class="menu-name">Manage Sections</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/master/tax-master/tax-list"
              (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-solid fa-file-invoice"></i></span>
              <span class="menu-name">Tax</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/master/common-master" (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-solid fa-magnet"></i></span>
              <span class="menu-name">Common Master</span>
            </a>
          </li>
        </ul>
      </li>
      <!---Master Menu-->

      <!---Transaction master-->
      <li class="sub-menu-li">
        <input id="group-2" type="radio" name="nav-main-group" hidden (change)="openSubGroup = null; openSubSubGroup = null" />
        <label class="nav-group" for="group-2" routerLinkActive="active">
          <span class="left-icon"><i class="fa fa-solid fa-money-bill-transfer"></i></span>
          <span class="menu-name">Transactions </span> <span class="right-arrow fa fa-angle-right"></span>
        </label>
        <ul class="group-list">
          <!------second level menu------->
          <li *ngIf="openSubGroup === null || openSubGroup === 'purchase'">
            <label class="nav-sub-group" [class.active-toggle]="openSubGroup === 'purchase'"
              (click)="toggleSubGroup('purchase')"><span class="left-icon"><i
                  class="fa fa-solid fa-sack-dollar"></i></span>
              <span class="menu-name">Purchase</span> <span class="right-arrow fa fa-angle-right"></span></label>
            <ul class="sub-group-list" [class.is-open]="openSubGroup === 'purchase'">
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/purchase-master/create-purchase-dc" (click)="togglemini()"><span
                    class="left-icon"><i class="fa fa-solid fa-cart-shopping"></i></span> <span class="menu-name"> Create
                    Purchase</span></a></li>
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/purchase-master/purchase-list/list" (click)="togglemini()"><span
                    class="left-icon"><i class="fa fa-solid fa-basket-shopping"></i></span> <span class="menu-name">
                    Purchase</span></a></li>
              <!-- <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/purchase-master/create-expenses/addnewrdexpenses"><span
                    class="left-icon"><i class="fa fa-solid fa-magnet"></i></span> <span class="menu-name"> Create
                    Expenses</span></a></li> -->
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/purchase-master/expense-list/list" (click)="togglemini()"><span
                    class="left-icon"><i class="fa fa-solid fa-bag-shopping"></i></span> <span class="menu-name">
                    Expenses</span></a></li>
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/purchase-master/create-expense-dc" (click)="togglemini()"><span
                    class="left-icon"><i class="fa fa-solid fa-file-invoice"></i></span> <span class="menu-name"> Create
                    Expense</span></a></li>
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/purchase-master/on-approval/onapproval" (click)="togglemini()"><span
                    class="left-icon"><i class="fa fa-regular fa-thumbs-up"></i></span> <span class="menu-name"> On
                    Approval</span></a></li>

              <!-- <li><a href="#"><span class="left-icon"><i class="fa fas fa-tachometer-alt"></i></span> <span
                        class="menu-name">2nd level nav item</span></a>
                  </li>
                  <li>
                    <input id="sub-sub-group-1" type="checkbox" hidden />
                    <label for="sub-sub-group-1"><span class="left-icon"><i class="fa fas fa-tachometer-alt"></i></span>
                      <span class="menu-name">Third level</span> <span class="right-arrow fa fa-angle-right"></span></label>
                    <ul class="sub-sub-group-list">
                      <li><a href="#"><span class="left-icon"><i class="fa fas fa-tachometer-alt"></i></span> <span
                            class="menu-name">3rd level nav item</span></a></li>
                      <li><a href="#"><span class="left-icon"><i class="fa fas fa-tachometer-alt"></i></span> <span
                            class="menu-name">3rd level nav item</span></a></li>
                      <li><a href="#"><span class="left-icon"><i class="fa fas fa-tachometer-alt"></i></span> <span
                            class="menu-name">3rd level nav item</span></a></li>
                    </ul>
                  </li> -->
            </ul>
          </li>
          <!------second level menu------->
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/transaction-master/debit-master/debit-list"
              (click)="togglemini()">
              <span class="left-icon"><i class="fa-solid fa-list"></i></span>
              <span class="menu-name">Debit Note</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/transaction-master/day-end-stocks"
              (click)="togglemini()">
              <span class="left-icon"><i class="fa-solid fa-list"></i></span>
              <span class="menu-name">Day end stock entry</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/transaction-master/verify-day-end-stocks"
              (click)="togglemini()">
              <span class="left-icon"><i class="fa-solid fa-list"></i></span>
              <span class="menu-name">verify day end stock</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active"
              routerLink="/transaction-master/credit-note-master/credit-note-list" (click)="togglemini()">
              <span class="left-icon"><i class="fa-solid fa-list"></i></span>
              <span class="menu-name">Credit Note</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active"
              routerLink="/transaction-master/journal-voucher-master/journal-voucher-list" (click)="togglemini()">
              <span class="left-icon"><i class="fa-solid fa-list"></i></span>
              <span class="menu-name">Journal Vouchers</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active"
              routerLink="/transaction-master/customer-order-entry-master/customer-order-entry-list/list"
              (click)="togglemini()">
              <span class="left-icon"><i class="fa-solid fa-list"></i></span>
              <span class="menu-name">Customer Order Entry</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/transaction-master/customer-inward"
              (click)="togglemini()">
              <span class="left-icon"><i class="fa-solid fa-list"></i></span>
              <span class="menu-name">Customer Inward</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active"
              routerLink="/transaction-master/payment-master/payment-list/paymentlist" (click)="togglemini()">
              <span class="left-icon"><i class="fa-solid fa-list"></i></span>
              <span class="menu-name">Payments</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active"
              routerLink="/transaction-master/payment-master/create-payment-dc" (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-solid fa-file-invoice"></i></span>
              <span class="menu-name">Create Payment</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active"
              routerLink="/transaction-master/payment-master/payment-list/receiptlist" (click)="togglemini()">
              <span class="left-icon"><i class="fa-solid fa-list"></i></span>
              <span class="menu-name">Receipts</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active"
              routerLink="/transaction-master/receipt-master/create-receipt-dc" (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-solid fa-file-invoice"></i></span>
              <span class="menu-name">Create Receipt</span>
            </a>
          </li>
          <!------second level menu------->
          <li *ngIf="openSubGroup === null || openSubGroup === 'karagir'">
            <label class="nav-sub-group" [class.active-toggle]="openSubGroup === 'karagir'"
              (click)="toggleSubGroup('karagir')"><span class="left-icon"><i
                  class="fa fa-solid fa-wand-magic-sparkles"></i></span>
              <span class="menu-name">Karagir</span> <span class="right-arrow fa fa-angle-right"></span></label>
            <ul class="sub-group-list" [class.is-open]="openSubGroup === 'karagir'">
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/karagir-master/inward-list/karinwlist" (click)="togglemini()"><span
                    class="left-icon"><i class="fa fa-solid fa-gear"></i></span> <span
                    class="menu-name">Inward</span></a></li>
              <li><a routerLinkActive="active" routerLink="/transaction-master/karagir-master/inward-list/karoutlist"
                  (click)="togglemini()"><span class="left-icon"><i class="fa fa-solid fa-gear"></i></span> <span
                    class="menu-name">Outward</span></a></li>
            </ul>
          </li>
          <li *ngIf="openSubGroup === null || openSubGroup === 'sales'">
            <label class="nav-sub-group" [class.active-toggle]="openSubGroup === 'sales'"
              (click)="toggleSubGroup('sales')"><span class="left-icon"><i
                  class="fa fa-solid fa-wand-magic-sparkles"></i></span>
              <span class="menu-name">Sales</span> <span class="right-arrow fa fa-angle-right"></span></label>
            <ul class="sub-group-list" [class.is-open]="openSubGroup === 'sales'">
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/sales-master/generate-mod-slip" (click)="togglemini()"><span
                    class="left-icon"><i class="fa fa-solid fa-gear"></i></span> <span class="menu-name">Generate Mod
                    Slip</span></a></li>
              <li style="display: none;"><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/sales-master/generate-token" (click)="togglemini()"><span
                    class="left-icon"><i class="fa fa-solid fa-gear"></i></span> <span class="menu-name">Generate
                    Token</span></a></li>
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/sales-master/sales-counter" (click)="togglemini()"><span
                    class="left-icon"><i class="fa fa-solid fa-gear"></i></span> <span class="menu-name">Sales
                    Counter</span></a></li>
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/sales-master/generate-invoice" (click)="togglemini()"><span
                    class="left-icon"><i class="fa fa-solid fa-gear"></i></span> <span class="menu-name">Generate
                    Invoice</span></a></li>
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/sales-master/invoice-list" (click)="togglemini()"><span
                    class="left-icon"><i class="fa fa-solid fa-gear"></i></span> <span class="menu-name">Invoice
                    List</span></a></li>
            </ul>
          </li>
          <li *ngIf="openSubGroup === null || openSubGroup === 'labelling'">
            <label class="nav-sub-group" [class.active-toggle]="openSubGroup === 'labelling'"
              (click)="toggleSubGroup('labelling')"><span class="left-icon"><i
                  class="fa fa-solid fa-wand-magic-sparkles"></i></span>
              <span class="menu-name">Labelling</span> <span class="right-arrow fa fa-angle-right"></span></label>
            <ul class="sub-group-list" [class.is-open]="openSubGroup === 'labelling'">
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/labelling-master/item-inward-details" (click)="togglemini()"><span
                    class="left-icon"><i class="fa fa-solid fa-gear"></i></span> <span class="menu-name">Item Inward
                    Details</span></a></li>
              <li style="display: none;"><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/labelling-master/item-inward-labels" (click)="togglemini()"><span
                    class="left-icon"><i class="fa fa-solid fa-gear"></i></span> <span class="menu-name">Item Inward
                    Labels</span></a></li>
            </ul>
          </li>
          <!------second level menu---------->
        </ul>
      </li>
      <!---Transaction master-->

      <!---Report master-->
      <li class="sub-menu-li">
        <input id="group-3" type="radio" name="nav-main-group" hidden (change)="openSubGroup = null; openSubSubGroup = null" />
        <label class="nav-group" for="group-3" routerLinkActive="active">
          <span class="left-icon"><i class="fa fa-solid fa-book-bookmark"></i></span>
          <span class="menu-name">Reports </span> <span class="right-arrow fa fa-angle-right"></span>
        </label>
        <ul class="group-list">
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/report-master/ledger-report"
              (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-regular fa-file-lines"></i></span>
              <span class="menu-name">Ledger Reports</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/report-master/receipt-register"
              (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-regular fa-file-lines"></i></span>
              <span class="menu-name">Receipt Register</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/report-master/karagir-inward-report"
              (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-regular fa-file-lines"></i></span>
              <span class="menu-name">Karagir Inward</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/report-master/account-group-bal"
              (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-regular fa-file-lines"></i></span>
              <span class="menu-name">Account Group Balance</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/report-master/bank-report"
              (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-regular fa-file-lines"></i></span>
              <span class="menu-name">Bank Reports</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/report-master/cash-book"
              (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-solid fa-money-bill-wave"></i></span>
              <span class="menu-name">Cash Book (Rojmel)</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/report-master/barcode-report"
              (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-solid fa-qrcode"></i></span>
              <span class="menu-name">Barcode Reports</span>
            </a>
          </li>

          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/report-master/gst-report"
              (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-solid fa-file-invoice-dollar"></i></span>
              <span class="menu-name">Gst Reports</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/report-master/stock-in-hand"
              (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-brands fa-stack-overflow"></i></span>
              <span class="menu-name">Stock in Hand</span>
            </a>
          </li>
          <!------second level menu------->
          <li *ngIf="openSubGroup === null || openSubGroup === 'registers'">
            <label class="nav-sub-group" [class.active-toggle]="openSubGroup === 'registers'"
              (click)="toggleSubGroup('registers')"><span class="left-icon"><i
                  class="fa fa-solid fa-book"></i></span>
              <span class="menu-name">Registers</span> <span class="right-arrow fa fa-angle-right"></span></label>
            <ul class="sub-group-list" [class.is-open]="openSubGroup === 'registers'">
              <li><a class="nav-link" routerLinkActive="active" routerLink="/report-master/purchase-register"
                  (click)="togglemini()"><span class="left-icon"><i class="fa fa-regular fa-file-lines"></i></span>
                  <span class="menu-name">Purchase Register</span></a></li>
              <li><a class="nav-link" routerLinkActive="active" routerLink="/report-master/expense-register"
                  (click)="togglemini()"><span class="left-icon"><i class="fa fa-regular fa-file-lines"></i></span>
                  <span class="menu-name">Expense Register</span></a></li>
            </ul>
          </li>
          <!------second level menu------->
        </ul>
      </li>
      <!---Report master-->

      <!---Utility master-->
      <li class="sub-menu-li">
        <input id="group-4" type="radio" name="nav-main-group" hidden (change)="openSubGroup = null; openSubSubGroup = null" />
        <label class="nav-group" for="group-4" routerLinkActive="active">
          <span class="left-icon"><i class="fa fa-solid fa-gears"></i></span>
          <span class="menu-name">Utility </span> <span class="right-arrow fa fa-angle-right"></span>
        </label>
        <ul class="group-list">
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/utility-master/fill-rates"
              (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-solid fa-receipt"></i></span>
              <span class="menu-name">Fill Rates</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/utility-master/manage-rates"
              (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-solid fa-sliders"></i></span>
              <span class="menu-name">Manage Rates</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/utility-master/rate-history"
              (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-solid fa-hand-holding-dollar"></i></span>
              <span class="menu-name">Rate History</span>
            </a>
          </li>
          <li *ngIf="openSubGroup === null">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/utility-master/access-control/role-list"
              (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-solid fa-shield-halved"></i></span>
              <span class="menu-name">Access Control</span>
            </a>
          </li>
          <!--second level menu  -->
          <li *ngIf="openSubGroup === null || openSubGroup === 'usermaintenance'">
            <label class="nav-sub-group" [class.active-toggle]="openSubGroup === 'usermaintenance'"
              (click)="toggleSubGroup('usermaintenance')"><span class="left-icon"><i
                  class="fa fa-solid fa-gear"></i></span>
              <span class="menu-name">User Maintanance</span> <span
                class="right-arrow fa fa-angle-right"></span></label>
            <ul class="sub-group-list" [class.is-open]="openSubGroup === 'usermaintenance'">
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/utility-master/user-maintanance/user-list/usermasterm" (click)="togglemini()"><span
                    class="left-icon"><i class="fa fa-regular fa-user"></i></span> <span
                    class="menu-name">User</span></a></li>
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/utility-master/user-maintanance/user-list/activeuserm" (click)="togglemini()"> <span
                    class="left-icon"><i class="fa fa-solid fa-user-shield"></i></span> <span class="menu-name">Active
                    User</span></a></li>
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/utility-master/user-maintanance/user-list/inactiveuserm" (click)="togglemini()"><span
                    class="left-icon"><i class="fa fa-solid fa-user-slash"></i></span> <span class="menu-name">Inactive
                    User</span></a></li>
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/utility-master/user-maintanance/user-list/lockeduserm" (click)="togglemini()"><span
                    class="left-icon"><i class="fa fa-solid fa-user-lock"></i></span> <span class="menu-name">locked
                    User</span></a></li>
            </ul>
          </li>
        </ul>
      </li>
      <!---Utility master-->

      <!---Ref Forms menu-->
      <li class="sub-menu-li">
        <input id="group-5" type="radio" name="nav-main-group" hidden (change)="openSubGroup = null; openSubSubGroup = null" />
        <label class="nav-group" for="group-5" routerLinkActive="active">
          <span class="left-icon"><i class="fa fa-solid fa-book"></i></span>
          <span class="menu-name">Ref Forms</span> <span class="right-arrow fa fa-angle-right"></span>
        </label>
        <ul class="group-list">
          <!-- The reactive-forms replacement (create-purchase-dc, "Jewelry Item Entry" Claude
               Design import) now has its own entry under Transactions > Purchase > Create
               Purchase, so it's no longer listed here. This old screen stays as a fallback
               for a while — remove once the new one's been confirmed stable in real use. -->
          <li>
            <a class="nav-sub-link" routerLinkActive="active"
              routerLink="/transaction-master/purchase-master/create-purchase/addnewrdpurchase" (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-solid fa-basket-shopping"></i></span>
              <span class="menu-name">Purchase (Old Design)</span>
            </a>
          </li>
          <li>
            <a class="nav-sub-link" routerLinkActive="active"
              routerLink="/transaction-master/purchase-master/create-expenses/addnewrdexpenses" (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-solid fa-bag-shopping"></i></span>
              <span class="menu-name">Expense (Old Design)</span>
            </a>
          </li>
          <li>
            <a class="nav-sub-link" routerLinkActive="active"
              routerLink="/transaction-master/payment-master/create-payment/receipt" (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-solid fa-receipt"></i></span>
              <span class="menu-name">Receipt (Old Design)</span>
            </a>
          </li>
          <li>
            <a class="nav-sub-link" routerLinkActive="active"
              routerLink="/transaction-master/payment-master/create-payment/payments" (click)="togglemini()">
              <span class="left-icon"><i class="fa fa-solid fa-money-bill"></i></span>
              <span class="menu-name">Payment (Old Design)</span>
            </a>
          </li>
        </ul>
      </li>
      <!---Ref Forms menu-->

      <!---Super Admin Controls menu-->
      <li class="sub-menu-li" *ngIf="canAccessSuperAdminControls">
        <input id="group-6" type="radio" name="nav-main-group" hidden (change)="openSubGroup = null; openSubSubGroup = null" />
        <label class="nav-group" for="group-6" routerLinkActive="active">
          <span class="left-icon"><i class="fa fa-solid fa-user-shield"></i></span>
          <span class="menu-name">Super Admin Controls</span> <span class="right-arrow fa fa-angle-right"></span>
        </label>
        <ul class="group-list">
          <li *ngIf="openSubGroup === null || openSubGroup === 'postingmapping'">
            <label class="nav-sub-group" [class.active-toggle]="openSubGroup === 'postingmapping'"
              (click)="toggleSubGroup('postingmapping')"><span class="left-icon"><i
                  class="fa fa-solid fa-diagram-project"></i></span>
              <span class="menu-name">Posting Mapping</span> <span class="right-arrow fa fa-angle-right"></span></label>
            <ul class="sub-group-list" [class.is-open]="openSubGroup === 'postingmapping'">
              <!-- Add one entry per screen as its posting mapping is wired up (Sales next). -->
              <li><a class="nav-link" routerLinkActive="active" routerLink="/super-admin/posting-mapping/purchase"
                  (click)="togglemini()">
                  <span class="left-icon"><i class="fa fa-solid fa-cart-shopping"></i></span>
                  <span class="menu-name">Purchase</span></a></li>
              <li><a class="nav-link" routerLinkActive="active" routerLink="/super-admin/posting-mapping/expense"
                  (click)="togglemini()">
                  <span class="left-icon"><i class="fa fa-solid fa-bag-shopping"></i></span>
                  <span class="menu-name">Expense</span></a></li>
              <li><a class="nav-link" routerLinkActive="active" routerLink="/super-admin/posting-mapping/karagir"
                  (click)="togglemini()">
                  <span class="left-icon"><i class="fa fa-solid fa-gem"></i></span>
                  <span class="menu-name">Karagir</span></a></li>
            </ul>
          </li>
        </ul>
      </li>
      <!---Super Admin Controls menu-->

      <li>
        <a class="nav-link" routerLinkActive="active" routerLink="/master/system-parameters" (click)="togglemini()">
          <span class="left-icon"><i class="fa fa-solid fa-sliders"></i></span>
          <span class="menu-name">System Parameters</span>
        </a>
      </li>

      <!-- <li>
            <a routerLink="/log-sheet">
              <span class="left-icon"><i class="fa fas fa-tachometer-alt"></i></span> <span class="menu-name">Menu 1</span>
            </a>
          </li> -->
    </ul>
  </nav>

  <div class="mini-sidebar">
    <span (click)="toggle()"></span>
  </div>
</div>